import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StripeService} from '../../../services/checkout/stripe.service';
import {PaymentResponseStatus, StripePaymentResponseIntent} from '../../../services/checkout/models/stripe';

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.scss']
})
export class StripeComponent implements OnInit, AfterViewInit {

  @Input() amount: number;
  @Input() description: string;

  @Output() paymentDone: EventEmitter<StripePaymentResponseIntent> = new EventEmitter();

  cvcInfo = false;

  formSubmitted = false;

  form: FormGroup;

  stripeErrorMessage: string | undefined = undefined;
  stripeCardDetailsNotTouched = true;
  paymentLoading = false;

  constructor(private fb: FormBuilder,
              private stripe: StripeService) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.stripe.initStripe();
    this.stripe.stripeCardElement.addEventListener('change', (event) => {
      this.stripeCardDetailsNotTouched = false;
      this.stripeErrorMessage = event.empty
        ? 'Credit or debit card is required.'
        : event.error ? event.error.message : undefined;
    });
  }

  private initForm(): void {
    this.form = this.fb.group({
      cardHolderName: ['', [Validators.required]],
      termsAndConditions: [false, [Validators.requiredTrue]]
    });
  }

  onSubmit(): void {
    this.formSubmitted = true;

    if (this.stripeCardDetailsNotTouched) {
      this.stripeErrorMessage = 'Credit or debit card is required.';
      this.form.markAllAsTouched();
      return;
    }

    if (this.form.valid) {
      this.paymentLoading = true;
      this.stripe.takePayment(this.amount, this.description, this.form.value.cardHolderName).subscribe((data) => {
        data.subscribe((paymentData) => {
          this.paymentLoading = false;

          if (paymentData?.error) {
            this.stripeErrorMessage = paymentData.error.message;
          }

          if (paymentData?.paymentIntent && paymentData.paymentIntent.status === PaymentResponseStatus.SUCCEEDED) {
            this.paymentDone.emit(paymentData.paymentIntent);
          }

        });
      });
    }
  }

  showCardCvcInfo(): void {
    this.cvcInfo = !this.cvcInfo;
  }
}
